import React from 'react';
import cls from 'classnames';

import { NavIconProps } from './NavIcon.types';

function NavIcon(props: NavIconProps) {
	const { iconLeft, iconRight, text, className } = props;

	return (
		<div className={cls('navIcon', className)}>
			<div>{iconLeft}</div>
			{text && <p>{text}</p>}
			<div>{iconRight}</div>
		</div>
	);
}

NavIcon.displayName = 'NavIcon';

export default NavIcon;
